import {
  type CustomerResource,
  type CustomerResourceDto,
  type CustomerResourcePage,
  type CustomerResourcePageDto,
} from "../../services/CustomerResourceService";
import mime from "mime";
import { filesize } from "filesize";
import { API_BASE_URL } from "../../constants";
import type CustomerId from "../../state/CustomerId";

export const toCustomerResource = (
  customerId: CustomerId,
  customerResource: CustomerResourceDto,
  thumbnailSize: number,
): CustomerResource => {
  const extension = mime.getExtension(customerResource.meta.contentType);
  return {
    id: customerResource.id,
    name: customerResource.meta.name,
    extension: extension ?? "Unknown",
    fileName: `${customerResource.meta.name}.${extension}`,
    fileSize: filesize(customerResource.length),
    source: `${API_BASE_URL}/api/v1.0/downloads/customers/${customerId}/resources?${customerResource.secureUri}`,
    sourceThumbnail: `${API_BASE_URL}/api/v1.0/downloads/customers/${customerId}/resources/thumbnail/${thumbnailSize}?${customerResource.secureUri}`,
  };
};

export const toCustomerResourcePage = (
  customerId: CustomerId,
  page: CustomerResourcePageDto,
  thumbnailSize: number,
): CustomerResourcePage => ({
  totalElements: page.totalElements,
  totalPages: page.totalPages,
  content: page.content.map((resource) => toCustomerResource(customerId, resource, thumbnailSize)),
  currentPage: page.number + 1, // Page in API is zero-based, we want to start at one
});
